var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-pane fade in active", attrs: { id: "tab_tracking" } },
    [
      _c("div", { staticClass: "tab__header" }, [_vm._v("Tracking Sheet")]),
      _vm._v(" "),
      _c("Comparisons"),
      _vm._v(" "),
      _c("TrackingSheetTable", {
        attrs: { title: "KPI Tracking", metrics: _vm.metricsKpiTracking }
      }),
      _vm._v(" "),
      _c("TrackingSheetTable", {
        attrs: {
          title: "Practice Locations & Provider Information",
          metrics: _vm.metricsLocationsAndProviders
        }
      }),
      _vm._v(" "),
      _c("TrackingSheetTable", {
        attrs: {
          title: "Testing Statistics",
          metrics: _vm.metricsTestingStatistics
        }
      }),
      _vm._v(" "),
      _c("TrackingSheetTable", {
        attrs: {
          title: "Treatment Statistics",
          metrics: _vm.metricsTreatmentStatistics
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tab__sub-header" }, [
        _vm._v("BENCHMARK CLASSIFICATION")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "kpi-table-wrapper" }, [
        _c("table", { staticClass: "kpi-table" }, [
          _c(
            "tr",
            { staticClass: "kpi-table__header" },
            _vm._l(_vm.monthAbbrevs, function(month) {
              return _c("th", [_vm._v(_vm._s(month))])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "tr",
            { staticClass: "kpi-table__metric" },
            [
              _vm._l(_vm.curYear, function(month, index) {
                return _c(
                  "td",
                  {
                    class: [
                      month.month === _vm.curMonth.month
                        ? "kpi-performance-table__month--selected"
                        : ""
                    ]
                  },
                  [_vm._v("\n          " + _vm._s(month.size) + "\n        ")]
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.emptyMonthsUntilEndOfYear, function(month) {
                return _c("td", [_vm._v(" - ")])
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend" }, [
      _c("span", { staticClass: "benchmark-size__label label label-info" }, [
        _vm._v("X Large")
      ]),
      _vm._v(" = 20+ Physicians    \n    "),
      _c("span", { staticClass: "benchmark-size__label label label-info" }, [
        _vm._v("Large")
      ]),
      _vm._v(" = 11-20 Physicians    \n    "),
      _c("span", { staticClass: "benchmark-size__label label label-info" }, [
        _vm._v("Medium")
      ]),
      _vm._v(" = 5–10 Physicians    \n    "),
      _c("span", { staticClass: "benchmark-size__label label label-info" }, [
        _vm._v("Small")
      ]),
      _vm._v(" = 1–4 Physicians    \n  ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }